<template>
  <el-popover popper-class="el-popover-activity-clean"
    placement="right" width="580"
    trigger="hover">
    <div class="flex flex-direction align-center justify-center">
      <div class="text-red text-lg text-600 text-center">如何选择文件分类、投稿作品</div>
      <div class="text-lg margin-top-sm text-center">可以按照文件分类，组别赛道、投稿作品</div>
      <div class="flex margin-top">
        <div class=" padding bg-gray radius" style="width: 335px;">
          <pre class="text-df">一、文件分类：
①选择“不分类”则所有投稿作品不做筛选，都在一个文件夹；
②如果活动设置了组别赛道，或者征稿单元，则可以，一个组别一个下载包，一个赛道一个下载包，按照不同的分组，将作品放在对应的组别文件里面；
二、投稿作品：                                                                                                                                                                                                                                                                                                                                                                                                        
①可以选择“每次投稿”为一个文件夹进行打包；或者所有上传人员的全部投稿都在一个文件夹里面。
②文件分类和投稿作品两部分可以组合使用</pre>
        </div>
        <img style="width: 148px;height: 297px;" src="https://assets.pfotoo.com/PC/ggtips.png" alt=""
          class="margin-left"></img>
      </div>

    </div>
    <div slot="reference" class="flex align-center justify-center">
      <div class="flex align-center justify-center text-blue">
        （查看示例）     
      </div>

    </div>

  </el-popover>
</template>

<script>
export default {
  components: {

  },
  props: {
  },
  data() {
    return {
      
    }
  },
  methods: {
    
  },
  mounted() {
    
  }
}
</script>

<style scoped lang="scss">
.fotoo-el-popover,
.fotoo-el-popover.el-popover {
  padding: 0;
}

.reference {
  cursor: pointer;


}


.activity-clean-icon {
  width: 9px;
  height: 9px;
  background-size: 100% 100%;
  background-image: url("https://assets.pfotoo.com/images/pc-help/question-circle-o%E5%A4%87%E4%BB%BD%203@2x@3x.png");
  margin-left: 5px;
}

</style>



// WEBPACK FOOTER //
// src/pages/components/ggtips-popover.vue